import React, { useContext } from 'react';
import { StyledCell } from '../body-cell/styled';
import { StyledBodyRow } from '../body-row/styled';
import styled from 'styled-components';
import { TableLayoutContext } from '../../layout-context';
const Wrapepr = styled.div `
  position: relative;
  z-index: 0;
`;
const bodyRowExpandedRenderMap = {
    table: ({ children, colSpan }) => (React.createElement(StyledBodyRow, { className: "invent-row-expanded" },
        React.createElement(StyledCell, { colSpan: colSpan },
            React.createElement(Wrapepr, null, children)))),
    block: ({ children }) => (React.createElement(StyledBodyRow, { as: "div", "aria-label": "subrow", role: "row", className: "invent-row-expanded" },
        React.createElement(StyledCell, { as: "div", role: "cell" },
            React.createElement(Wrapepr, null, children))))
};
export const TableBodyRowExpanded = ({ children, colSpan }) => {
    const layoutType = useContext(TableLayoutContext);
    const renderBodyRowExpanded = bodyRowExpandedRenderMap[layoutType];
    return renderBodyRowExpanded({ children, colSpan });
};
